import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../contexts/user.context';
import { OrderProviderValue, StoreProviderValue, UserProviderValue } from '../models';
import { MembershipReward } from '../components';
import { StoreContext } from '../contexts/store.context';
import { OrderContext } from '../contexts/order.context';
import { formatNumber, getLinkWithParams, getTimeAgo } from '../utils';
import { HowItWorksBanner } from '../components/HowItWorksBanner';
import { CluheadCoversMintBanner } from '../components/CluheadCoversMintBanner';
import { CluheadCoversExplore } from '../components/CluheadCoversExplore';

export function HomePage() {
   const { userReferrals } = useContext<UserProviderValue>(UserContext);
   const { userRaffleEntries } = useContext<StoreProviderValue>(StoreContext);
   const { orders } = useContext<OrderProviderValue>(OrderContext);

   return (
      <div className="grid gap-3 w-100">
         <div className="grid grid-cols-2 gap-3 w-100">
            {/* <CluheadCoversMintBanner /> */}
            <CluheadCoversExplore />
            <HowItWorksBanner />
         </div>

         <div className="grid grid-cols-3 gap-3 w-100">
            <Link
               to={getLinkWithParams('/referral-center')}
               className="box bg-gray grid-item span-2 flex items-start wrap gap-3">
               <div className="flex flex-col gap-2 flex-2">
                  <div className="flex items-center gap-2">
                     <img
                        src="/assets/icons/referral-icon.svg"
                        alt=""
                        width={25}
                     />
                     <h2>Referral Center</h2>
                  </div>
                  <span className="gray">{(userReferrals.counts.signups ?? 0) > 0 ? 'Boost rewards' : 'Refer paying members to earn a free membership!'} </span>
               </div>

               {(userReferrals.counts.signups ?? 0) > 0 ? (
                  <div className="box bg-light-gray flex items-center justify-center gap-4 flex-3">
                     <div className="flex flex-col items-center gap-1">
                        <h2 className="green">{userReferrals.counts.signups ?? 0}</h2>
                        <span className="gray text-center nowrap">Sign ups</span>
                     </div>
                     <div className="flex flex-col items-center gap-1">
                        <h2 className="green">{userReferrals.counts.profilesCompleted ?? 0}</h2>
                        <span className="gray text-center nowrap">Active members</span>
                     </div>
                  </div>
               ) : (
                  <MembershipReward
                     icon="/assets/icons/memberships/green-icon.svg"
                     name="Membership"
                  />
               )}
            </Link>
            <Link
               to={getLinkWithParams('/sweepstakes')}
               className="box bg-green-gradient grid-item span-1 flex flex-col gap-2">
               <div className="flex items-center gap-2">
                  <img
                     src="/assets/icons/gift-icon.svg"
                     alt=""
                     width={25}
                  />
                  <h2>Sweepstakes</h2>
               </div>
               {/* <span className="gray">Win once-in-a-lifetime prizes!</span> */}
            </Link>
            <Link
               to={getLinkWithParams('/my-entries')}
               className="box bg-gray grid-item span-1 flex justify-between gap-3 wrap">
               <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                     <img
                        src="/assets/icons/auction-icon.svg"
                        alt=""
                        width={25}
                     />
                     <h2>My Entries</h2>
                  </div>
                  <span className="gray">All your entered sweepstakes in one place</span>
               </div>
               {(userRaffleEntries.pagination.total ?? 0) > 0 && (
                  <div className="flex flex-col gap-2 items-center">
                     <div className="entries-total">{formatNumber(userRaffleEntries.pagination.total ?? 0)}</div>
                     {(orders.pagination.total ?? 0) > 0 && orders.orders !== null && (
                        <div className="flex flex-col items-center">
                           <span className="small gray nowrap">Last entry</span>
                           <span className="small green nowrap">{getTimeAgo(new Date(orders.orders[0].createdAt))}</span>
                        </div>
                     )}
                  </div>
               )}
            </Link>

            {/* <Link
               to={getLinkWithParams('/convert')}
               className="box bg-gray grid-item span-1 flex justify-between gap-3 wrap">
               <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                     <img
                        src="/assets/icons/swap-white.svg"
                        alt=""
                        width={25}
                     />
                     <h2>Convertion Center</h2>
                  </div>
                  <span className="gray">Convert GolfN points into $GOLF tokens and vice versa.</span>
               </div>
            </Link> */}
            <Link
               // to={getLinkWithParams('/memberships')}
               to={'https://www.golfn.com/membership-golfer'}
               target="_blank"
               className="box bg-gray grid-item span-1 flex flex-col gap-3">
               <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                     <img
                        src="/assets/icons/membership-icon.svg"
                        alt=""
                        width={25}
                     />
                     <h2>Memberships</h2>
                  </div>
                  <span>Green, white, silver, gold, diamond levels</span>
               </div>
               {/* <div className="flex items-center">
                  <img
                     src="/assets/icons/lock-icon-lighter.svg"
                     alt=""
                     width={25}
                  />
                  <span className="gray">Coming Soon</span>
               </div> */}
            </Link>

            <Link
               to={getLinkWithParams('/passport-and-map')}
               className="box bg-gray grid-item span-1 flex flex-col gap-3 opacity-50">
               <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                     <img
                        src="/assets/icons/map-icon.svg"
                        alt=""
                        width={25}
                     />
                     <h2>Passport/Map</h2>
                  </div>
                  <span>Charity score & pinned courses</span>
               </div>
               <div className="flex items-center">
                  <img
                     src="/assets/icons/lock-icon-lighter.svg"
                     alt=""
                     width={25}
                  />
                  <span className="gray">Coming Soon</span>
               </div>
            </Link>
            <Link
               to={getLinkWithParams('/compete-and-connect')}
               className="box bg-gray grid-item span-1 flex flex-col gap-3 opacity-50">
               <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                     <img
                        src="/assets/icons/globe-icon.svg"
                        alt=""
                        width={25}
                     />
                     <h2>Compete/Connect</h2>
                  </div>
                  <span>Leagues, tournaments, clubs</span>
               </div>
               <div className="flex items-center">
                  <img
                     src="/assets/icons/lock-icon-lighter.svg"
                     alt=""
                     width={25}
                  />
                  <span className="gray">Coming Soon</span>
               </div>
            </Link>
            <Link
               to={getLinkWithParams('/achievements')}
               className="box bg-gray grid-item span-1 flex flex-col gap-3 opacity-50">
               <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                     <img
                        src="/assets/icons/trophy-icon.svg"
                        alt=""
                        width={25}
                     />
                     <h2>Achievements</h2>
                  </div>
                  <span>Track personal & certified achievements</span>
               </div>
               <div className="flex items-center">
                  <img
                     src="/assets/icons/lock-icon-lighter.svg"
                     alt=""
                     width={25}
                  />
                  <span className="gray">Coming Soon</span>
               </div>
            </Link>

            <Link
               to={getLinkWithParams('/my-game')}
               className="box bg-gray grid-item span-1 flex flex-col gap-3 opacity-50">
               <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                     <img
                        src="/assets/icons/golfer-icon.svg"
                        alt=""
                        width={25}
                     />
                     <h2 className="">My Game</h2>
                  </div>
                  <span className="">Handicap, round stats, etc.</span>
               </div>
               <div className="flex items-center">
                  <img
                     src="/assets/icons/lock-icon-lighter.svg"
                     alt=""
                     width={25}
                  />
                  <span className="gray">Coming Soon</span>
               </div>
            </Link>
         </div>
      </div>
   );
}
